<template>
  <v-expansion-panels v-model="subscriptionsPanel">
    <v-expansion-panel>
      <v-expansion-panel-header class="text-h6 font-weight-regular">
        <v-row>
          <v-col md="auto">
            {{ $t('EREPORTER.INVOICES.ITEMS') }}
          </v-col>
          <v-spacer />
          <v-col md="auto">
            <v-btn class="mr-4" outlined color="indigo" @click.stop="create">
              <v-icon left>mdi-plus</v-icon>
              {{ $t('ITEM.NEW') }} {{ $t('EREPORTER.INVOICES.ITEM') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <invoices-list
          :invoices="invoices"
          :options.sync="options"
          :meta="meta"
          type="c"
          @show="show"
          @refresh="getDataInvoices"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="1200"
    >
      <create-invoice
        :customer-id="companyId"
        :customer-type="$options.BUSINESS"
        :errors="errors.getAll()"
        @cancel="cancelDialog"
        @create="createInvoice"
        @update-prop="clearErrorByName($event)"
      ></create-invoice>
    </v-dialog>
  </v-expansion-panels>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import DataOptions from '@/modules/_global/classes/DataOptions';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { mapActions } from 'vuex';
import InvoicesList from '@/modules/ereporter/components/Invoices/InvoicesList';
import CreateInvoice from '@/modules/ereporter/components/Invoices/CreateInvoice';
import { onceRequest } from '@/modules/_global/utils/common';
import { BUSINESS } from '@/modules/ereporter/common/Invoices/customerTypes';

export default {
  name: 'CompanyInvoicesList',

  BUSINESS,

  components: {
    InvoicesList,
    CreateInvoice
  },

  mixins: [errors, i18nRefreshData],

  props: {
    companyId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      invoices: [],
      meta: {
        total: 0
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['period'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      error: null,
      dialog: false,
      subscriptionsPanel: 1
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    }
  },

  watch: {
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    }
  },

  mounted() {
    this.getDataInvoices();
  },

  methods: {
    ...mapActions('ereporter', ['getBInvoices', 'createBInvoice']),
    refreshData() {
      this.getDataInvoices();
    },

    getDataInvoices() {
      return this.getBInvoices({
        id: this.companyId,
        params: this.preparedOptions
      })
        .then(({ data }) => {
          this.meta = data.meta;
          this.invoices = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    create() {
      this.dialog = true;
    },

    createInvoice: onceRequest(function createInvoice(v) {
      return this.createBInvoice({ id: this.companyId, invoice: v })
        .then(() => {
          this.cancelDialog();
          this.refreshData();
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }),

    cancelDialog() {
      this.dialog = false;
    },

    show(item) {
      this.$router.push({
        name: 'ereporter.invoice.show',
        params: { id: item.id }
      });
    },

    openPanel() {
      this.subscriptionsPanel = 0;
    }
  }
};
</script>

<style scoped></style>
